<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.provinceName"
              placeholder="请输入省区名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @stop="stopFun(arguments)"
        @start="startFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { loadSurveyCityCountSettingListDataApi, loadSurveyCityCountSettingExportDataApi, saveOrUpdateSurveyCityCountSettingApi } from '@/api/surveyCityCountSetting'
export default {
  name: 'SurveyCityCountSetting',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'base_survey_city_count_setting_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['survey_city_count_setting_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['survey_city_count_setting_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['survey_city_count_setting_stop'],
            prop: 'stop',
            label: '停用',
            method: 'stop'
          },
          {
            permissionSigns: ['survey_city_count_setting_start'],
            prop: 'start',
            label: '启用',
            method: 'start'
          },
          {
            permissionSigns: ['survey_city_count_setting_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['survey_city_count_setting_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            provinceName: ''
          }
        }
      },
      id: null, // 选中的单据ID
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      eventType: ''
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 120 },
      { prop: 'cityName', label: '城市', filterColumn: 'city_name', width: 120 },
      { prop: 'count', label: '采集户数', width: 120 },
      { prop: 'statusStr', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '启用', value: 1 }, { label: '停用', value: 2 }], width: 120 },
      { prop: 'remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 120 },
      { prop: 'operationTimeStr', filterColumn: 'operation_time', label: '操作时间', width: 180, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadSurveyCityCountSettingListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    //新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '新增单品调查城市户数信息'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改单品调查城市户数信息'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '查看单品调查城市户数信息'
    },
    // 停用
    stopFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status === 2) {
        this.$message({
          message: '数据不在启用状态，不能停用',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定停用该单品调查城市户数信息？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateSurveyCityCountSettingApi({ id: args[0].id, isStop: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 启用
    startFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status === 1) {
        this.$message({
          message: '数据不在停用状态，不能启用',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定启用该单品调查城市户数信息？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateSurveyCityCountSettingApi({ id: args[0].id, isStart: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadSurveyCityCountSettingExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
